import React, { useEffect } from "react";
import Moment from "moment";
import chroma from "chroma-js";
import { ReportingPackageStatusItem } from "AppSrc/user/projectItem/reportingPackageStatusItem";
import { connect } from "react-redux";
import Traec from "traec";

export const RelatedCommits = props => {
  let commits = props.project.get("related_commits");
  if (!commits) {
    return null;
  }

  let projectId = props.project.get("uid");

  return commits.map((commit, i) => {
    if (commit.get("is_staging")) {
      return null;
    }
    let commitId = commit.get("uid");
    let refId = commit.get("ref");
    if (!refId) {
      return null;
    }
    let refName = getRefName({
      refs: props.refs,
      refId,
      trackerId: commit.get("tracker")
    });

    // Get the string of this reporting period
    let startDate = commit.getInPath("reporting_period_data.startDate");
    let endDate = commit.getInPath("reporting_period_data.endDate");
    let dates = `${Moment(startDate).format("Do MMM YY")} to ${Moment(endDate)
      .add(-1, "days")
      .format("Do MMM YY")}`;

    // Get the status
    let status = commit.getInPath("meta_json.status");
    switch (status) {
      case "pending_approval":
        status = "Pending Approval";
        break;
      case "pending_revision":
        status = "Requires Revision";
        break;
      case "approved":
        status = "Approved";
        break;
      default:
        break;
    }

    let color = chroma("#ffff99")
      .brighten(1)
      .hex();

    return (
      <ReportingPackageStatusItem
        index={i}
        key={i}
        projectId={projectId}
        refId={refId}
        refName={refName}
        commitId={commitId}
        status={status}
        color={color}
        dates={dates}
      />
    );
  });
};

const mapStateToProps = (state, ownProps) => {
  let refs = state.getInPath(`entities.refs.byId`);
  return { refs };
};

export default connect(mapStateToProps)(RelatedCommits);

const getRefName = props => {
  // This is not required - if we didn't get a Ref from the tracker_refs endpoint
  // then it shouldn't be fetched anyway
  /*useEffect(() => {
    Traec.fetchRequiredFor({ props, requiredFetches: [
      new Traec.Fetch("tracker_ref", "read"),
    ]})
  });*/

  let { refs, refId, trackerId } = props;
  let name = refs ? refs.getIn([refId, "name"]) : null;
  if (name) {
    return name;
  } else {
    return "Reporting Package";
  }
};
